import { IRevenueSpendListTableLang } from '../../../types/lang'

export const revenueSpendListTableLang: IRevenueSpendListTableLang = {
	revenue_spend_list_table: {
		column_id: 'ID_ru',
		column_date: 'Date_ru',
		column_date_updated: 'Date Updated_ru',
		column_amount: 'Amount_ru',
		column_account_id: 'Account ID_ru',
		column_account: 'Account_ru',
		column_account_in_group: 'Account in Group_ru',
		column_kt_group: 'KT Group_ru',
		column_agency_id: 'Agency ID_ru',
		column_agency: 'Agency_ru',
		column_history: 'History_ru',
		column_notes: 'Notes_ru'
	}
}